import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CourseCatalogComponent } from './course-catalog.component';
import { PageGuard, PageType } from 'src/app/core/services/page-guard.service';
import { DeactivateGuard } from 'src/app/core/services/can-deactivate-guard';



const routes: Routes = [
    {
        path: '',
        canActivate: [PageGuard],
        canDeactivate: [DeactivateGuard],
        component: CourseCatalogComponent,
        data: { Page: PageType.Catalog }
    }    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CourseCatalogRoutingModule { }
